const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const CONTACT_EMAIL = "hello@reachthepeople.ai";

const CONTACT_PHONE_NUMBER = "202-972-5691";
const CONTACT_PHONE_NUMBER_DISPLAY = "(202) 972-5691";
const CONTACT_PHONE_NUMBER_RAW = CONTACT_PHONE_NUMBER.replaceAll("-", "");

const COMPANY_NAME = "ReachThePeople.ai";

const CONTACT_ADDRESS = [
  "SalesStreamAI LLC",
  "1629 K St. N.W. Suite 300",
  "Washington D.C. 20006",
];
const CONTACT_ADDRESS_SHORT = CONTACT_ADDRESS.slice(1);
const CONTACT_ADDRESS_SHORT_STR = CONTACT_ADDRESS_SHORT.join(", "); // 1629 K St. N.W. Suite 300, Washington D.C. 20006

const SOCIAL_LINKS = [
  {
    platform: "linkedin",
    iconSrc: "/images/icons/social/social-linkedin.svg",
    alt: "Social icon - LinkedIn",
    iconWidth: "14px",
    showIn: ["blogPost", "footer"],
  },
  {
    platform: "facebook",
    iconSrc: "/images/icons/social/social-fb.svg",
    alt: "Social icon - facebook",
    iconWidth: "16px",
    showIn: ["blogPost", "footer"],
  },
  {
    platform: "twitter",
    iconSrc: "/images/icons/social/social-x.svg",
    alt: "Social icon - X",
    iconWidth: "14px",
    showIn: ["blogPost", "footer"],
  },
  {
    platform: "instagram",
    iconSrc: "/images/icons/social/social-instagram.svg",
    alt: "Social icon - Instagram",
    iconWidth: "14px",
    showIn: ["footer"],
  },
];

const MOBILE_BREAKPOINT = 768; // src/theme.js > theme.media.mobile
const TABLET_BREAKPOINT = 1200; // src/theme.js > theme.media.tablet
const HEADER_HEIGHT = 74;
const HEADER_HEIGHT_MOBILE = 60;
const BANNER_HEIGHT = 40;

const HOMEPAGE_ANCHOR_CONTAINER_IDs = {
  aboutReach: {
    key: "aboutReach",
  },
  hero: {
    key: "hero",
  },
  features: {
    key: "features",
  },
  benefits: {
    key: "benefits",
  },
  useCases: {
    key: "solutions",
  },
  testimonials: {
    key: "testimonials",
  },
  contactUs: {
    key: "contact",
  },
  cta: {
    key: "cta",
  },
  faq: {
    key: "faq",
  },
  channels: {
    key: "channels",
  },
  directMail: {
    key: "direct-mail",
  },
  autoreplies: {
    key: "autoreplies",
  },
  polling: {
    key: "polling",
  },
  data: {
    key: "data",
  },
};

const SUPPORT_EMAIL = "support@reachthepeople.ai";

const PRIVACY_POLICY_CONTENT = [
  {
    id: 1,
    title: "Intellectual Property Rights",
    textArray: [
      "Other than the content you own, under these Terms, ReachThePeople.ai and/or its licensors own all the intellectual property rights and materials contained in this Website",
      "You are granted limited license only for purposes of viewing the material contained on this Website.",
    ],
  },
  {
    id: 2,
    title: "Restriction",
    textArray: [
      "Unless specifically authorized, you are specifically restricted from all of the following:",
      "{middot}publishing any Website material in any other media;",
      "{middot}selling, sublicensing and/or otherwise commercializing any Website material;",
      "{middot}publicly performing and/or showing any Website material;",
      "{middot}using this Website in any way that is or may be damaging to this Website / Company Reputation",
      "{middot}using this Website in any way that impacts user access to this Website;",
      "{middot}using this Website contrary to applicable laws and regulations, or in any way may cause harm to the Website, or to any person or business entity;",
      "{middot}engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website;",
      "{middot}using this Website to engage in any advertising or marketing.",
      "Certain areas of this Website are restricted from being access by you, and ReachThePeople.ai may further restrict access by you to any areas of this Website, at any time, at its absolute discretion. Any user ID and password you may have for this Website are confidential and you must maintain confidentiality as well.",
    ],
  },
  {
    id: 3,
    title: "Your Content",
    textArray: [
      "In these Terms of Use, “Your Content” shall mean any audio, video text, images or other material you upload at your free will on this Website. By uploading Your Content, you grant ReachThePeople.ai a non-exclusive, worldwide, irrevocable, sub-licensable license to use, reproduce, adapt, publish, translate and distribute it in any and all media.",
      "Your Content must be your own and must not be invading any third-party's rights. ReachThePeople.ai reserves the right to remove any of Your Content from this Website at any time without notice. For documentation like Requests for Proposal and Confidential business information, we advise getting in touch with your representatives to maintain confidentiality at all times.",
    ],
  },
  {
    id: 4,
    title: "User Data Collection",
    textArray: [
      "Our Chrome Extension ('ReachThePeople.ai Reach') collects certain user data to provide and improve our services. The types of data we collect include:",
      "{middot}Browser data: Information related to your browser version, type, and settings that help us ensure compatibility and optimal performance.",
      "{middot}Usage data: Details about how you interact with our extension, which can include the features you use and the time spent on our extension.",
    ],
  },
  {
    id: 5,
    title: "Data Handling and Storage",
    textArray: [
      "We take the privacy and security of your data seriously. To that end, we implement the following measures:",
      "{middot}Data handling: All user data is handled in strict accordance with this privacy policy and is used solely for the purposes outlined herein.",
      "{middot}Data storage: Collected data is stored on secure servers with restricted access. We retain user data only for as long as necessary to provide our services or as required by law.",
      "{middot}Data encryption: We use industry-standard encryption methods to protect your data from unauthorized access during transmission and storage.",
    ],
  },
  {
    id: 6,
    title: "Data Sharing",
    textArray: [
      "We do not sell or rent your personal information to third parties. However, we may share user data in the following circumstances:",
      "{middot}With service providers: We may share your data with third-party service providers who perform services on our behalf, such as hosting, analytics, and customer service. These providers are bound by confidentiality agreements and are permitted to use the data only for the purposes for which they have been engaged.",
      "{middot}For legal reasons: We may disclose your data if required by law or if we believe in good faith that such action is necessary to comply with legal processes, enforce our policies, or protect the rights, property, or safety of our users or the public.",
      "{middot}In case of business transfer: In the event of a merger, acquisition, or asset sale, your data may be transferred. We will provide notice before your data is transferred and becomes subject to a different privacy policy.",
    ],
  },
  {
    id: 7,
    title: "Your Rights",
    textArray: [
      "You have certain rights regarding your data, including the right to access, correct, or delete your personal information. If you wish to exercise these rights or have any questions about our data practices, please contact us at {link:href-mailto:info@reachthepeople.ai;text-info@reachthepeople.ai}",
    ],
  },
  {
    id: 8,
    title: "Limitation of liability",
    textArray: [
      "In no event shall ReachThePeople.ai, nor any of its officers, directors and employees, shall be held liable for anything arising out of or in any way connected with your use of this Website whether such liability is under contract. ReachThePeople.ai, including its officers, directors and employees shall not be held liable for any indirect, consequential or special liability arising out of or in any way related to your use of this Website.",
    ],
  },
  {
    id: 9,
    title: "Indemnification",
    textArray: [
      "You hereby indemnify to the fullest extent ReachThePeople.ai and its executive officers, partners, employees, and other stakeholders, from and against any and/or all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms",
    ],
  },
  {
    id: 10,
    title: "Severability",
    textArray: [
      "If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be deleted without affecting the remaining provisions herein.",
    ],
  },
  {
    id: 11,
    title: "Variation of Terms",
    textArray: [
      "ReachThePeople.ai reserves the right to revise these Terms of Use at any time as it sees fit, and by using this Website you are expected to review these Terms on a regular basis.",
    ],
  },
  {
    id: 12,
    title: "Assignment",
    textArray: [
      "ReachThePeople.ai is allowed to assign, transfer, and subcontract its rights and/or obligations under these Terms without any notification. However, you are not allowed to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.",
    ],
  },
  {
    id: 13,
    title: "Entire Agreement",
    textArray: [
      "These Terms constitute the entire agreement between ReachThePeople.ai and you in relation to your use of this Website, and supersede all prior agreements and understandings.",
    ],
  },
  {
    id: 14,
    title: "Governing Law & Jurisdiction",
    textArray: [
      "These Terms of Use will be governed by, and interpreted in accordance with, the laws of the Republic of India, and you submit to the exclusive jurisdiction of the relevant courts in the Union Territory of Chandigarh, India for the resolution of any disputes.",
    ],
  },
  {
    id: 15,
    title: "Contacting Us",
    textArray: [
      "We are committed to ensuring you have all the information you need to make informed decisions about your privacy, and your use of our products and services, including this website. If you have any questions we haven’t addressed here, please feel free to reach out to us here. Stay Safe.",
    ],
  },
  {
    id: 1001,
    title: "SMS Text Program Privacy",
    textArray: [
      "We collect mobile numbers solely to send campaign-related text updates that you request.",
      "We do not sell or share your mobile number with third parties.",
      "You can opt out at any time by replying STOP. For assistance, reply HELP.",
    ],
  },
];

const TERMS_CONDITIONS_CONTENT = [
  {
    id: 1,
    title: "Intellectual Property Rights",
    textArray: [
      "Other than the content you own, under these Terms, ReachThePeople.ai and/or its licensors own all the intellectual property rights and materials contained in this Website",
      "You are granted limited license only for purposes of viewing the material contained on this Website.",
    ],
  },
  {
    id: 2,
    title: "Restriction",
    textArray: [
      "Unless specifically authorised, you are specifically restricted from all of the following:",
      "{middot}publishing any Website material in any other media;",
      "{middot}selling, sublicensing and/or otherwise commercializing any Website material;",
      "{middot}publicly performing and/or showing any Website material;",
      "{middot}using this Website in any way that is or may be damaging to this Website / Company Reputation;",
      "{middot}using this Website in any way that impacts user access to this Website;",
      "{middot}using this Website contrary to applicable laws and regulations, or in any way may cause harm to the Website, or to any person or business entity;",
      "{middot}engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website;",
      "{middot}using this Website to engage in any advertising or marketing.",
      "Certain areas of this Website are restricted from being access by you, and ReachThePeople.ai may further restrict access by you to any areas of this Website, at any time, at its absolute discretion. Any user ID and password you may have for this Website are confidential and you must maintain confidentiality as well.",
    ],
  },
  {
    id: 3,
    title: "Your Content",
    textArray: [
      "In these Terms of Use, “Your Content” shall mean any audio, video text, images or other material you upload at your free will on this Website. By uploading Your Content, you grant ReachThePeople.ai a non-exclusive, worldwide, irrevocable, sub-licensable license to use, reproduce, adapt, publish, translate and distribute it in any and all media.",
      "Your Content must be your own and must not be invading any third-party's rights. ReachThePeople.ai reserves the right to remove any of Your Content from this Website at any time without notice. For documentation like Requests for Proposal and Confidential business information, we advise getting in touch with your representatives to maintain confidentiality at all times.",
    ],
  },
  {
    id: 4,
    title: "User Data Collection",
    textArray: [
      "Our Chrome Extension ('ReachThePeople.ai Reach') collects certain user data to provide and improve our services. The types of data we collect include:",
      "{middot}Browser data: Information related to your browser version, type, and settings that help us ensure compatibility and optimal performance.",
      "{middot}Usage data: Details about how you interact with our extension, which can include the features you use and the time spent on our extension.",
    ],
  },
  {
    id: 5,
    title: "Data Handling and Storage",
    textArray: [
      "We take the privacy and security of your data seriously. To that end, we implement the following measures:",
      "{middot}Data handling: All user data is handled in strict accordance with this privacy policy and is used solely for the purposes outlined herein.",
      "{middot}Data storage: Collected data is stored on secure servers with restricted access. We retain user data only for as long as necessary to provide our services or as required by law.",
      "{middot}Data encryption: We use industry-standard encryption methods to protect your data from unauthorized access during transmission and storage.",
    ],
  },
  {
    id: 6,
    title: "Data Sharing",
    textArray: [
      "We do not sell or rent your personal information to third parties. However, we may share user data in the following circumstances:",
      "{middot}With service providers: We may share your data with third-party service providers who perform services on our behalf, such as hosting, analytics, and customer service. These providers are bound by confidentiality agreements and are permitted to use the data only for the purposes for which they have been engaged.",
      "{middot}For legal reasons: We may disclose your data if required by law or if we believe in good faith that such action is necessary to comply with legal processes, enforce our policies, or protect the rights, property, or safety of our users or the public.",
      "{middot}In case of business transfer: In the event of a merger, acquisition, or asset sale, your data may be transferred. We will provide notice before your data is transferred and becomes subject to a different privacy policy.",
    ],
  },
  {
    id: 7,
    title: "Your Rights",
    textArray: [
      "You have certain rights regarding your data, including the right to access, correct, or delete your personal information. If you wish to exercise these rights or have any questions about our data practices, please contact us at {link:href-mailto:info@reachthepeople.ai;text-info@reachthepeople.ai}",
    ],
  },
  {
    id: 8,
    title: "Limitation of liability",
    textArray: [
      "In no event shall ReachThePeople.ai, nor any of its officers, directors and employees, shall be held liable for anything arising out of or in any way connected with your use of this Website whether such liability is under contract. ReachThePeople.ai, including its officers, directors and employees shall not be held liable for any indirect, consequential or special liability arising out of or in any way related to your use of this Website.",
    ],
  },
  {
    id: 9,
    title: "Indemnification",
    textArray: [
      "You hereby indemnify to the fullest extent ReachThePeople.ai and its executive officers, partners, employees, and other stakeholders, from and against any and/or all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms",
    ],
  },
  {
    id: 10,
    title: "Severability",
    textArray: [
      "If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be deleted without affecting the remaining provisions herein.",
    ],
  },
  {
    id: 11,
    title: "Variation of Terms",
    textArray: [
      "ReachThePeople.ai reserves the right to revise these Terms of Use at any time as it sees fit, and by using this Website you are expected to review these Terms on a regular basis.",
    ],
  },
  {
    id: 12,
    title: "Assignment",
    textArray: [
      "ReachThePeople.ai is allowed to assign, transfer, and subcontract its rights and/or obligations under these Terms without any notification. However, you are not allowed to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.",
    ],
  },
  {
    id: 13,
    title: "Entire Agreement",
    textArray: [
      "These Terms constitute the entire agreement between ReachThePeople.ai and you in relation to your use of this Website, and supersede all prior agreements and understandings.",
    ],
  },
  {
    id: 14,
    title: "Governing Law & Jurisdiction",
    textArray: [
      "These Terms of Use will be governed by, and interpreted in accordance with, the laws of the Republic of India, and you submit to the exclusive jurisdiction of the relevant courts in the Union Territory of Chandigarh, India for the resolution of any disputes.",
    ],
  },
  {
    title: "Google App Disclosure",
    textArray: [
      "Reach's use and transfer of information received from Google APIs to any other app will adhere to  {link:href-https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes;text-Google API Services User Data Policy}, including the Limited Use requirements.",
    ],
  },
  {
    id: 15,
    title: "Contacting Us",
    textArray: [
      "We are committed to ensuring you have all the information you need to make informed decisions about your privacy, and your use of our products and services, including this website. If you have any questions we haven’t addressed here, please feel free to reach out to us here. Stay Safe.",
    ],
  },
  {
    id: 1002,
    title: "SMS Text Program Terms",
    textArray: [
      "Campaign text messages are recurring and may vary by activity (approximately 2–6 messages per month).",
      "Message and data rates may apply; delivery is subject to carrier performance.",
      "Reply STOP to cancel at any time; reply HELP for help.",
    ],
  },
];

const COOKIES_POLICY_CONTENT = [
  {
    id: 1,
    title: "What Are Cookies?",
    textArray: [
      "Cookies are small text files that are placed on your device when you visit a website. They help us understand how the site is being used, remember user preferences, and improve functionality.",
    ],
  },
  {
    id: 2,
    title: "Types of Cookies We Use",
    textArray: [
      "We use the following types of cookies:",
      "<strong>a. Essential Cookies</strong>",
      "These cookies are necessary for the website to function properly. They enable core features such as security, network management, and accessibility. You cannot opt out of these cookies.",
      "<strong>b. Analytics and Performance Cookies</strong>",
      "We use these cookies to understand how visitors interact with our website. This helps us improve content and performance. For example, we use tools like Google Analytics to collect anonymized information such as the number of visitors, where they come from, and how they navigate our site.",
    ],
  },
  {
    id: 3,
    title: "Managing Cookies",
    textArray: [
      "You can control or delete cookies through your browser settings. Most browsers allow you to block or delete cookies, but doing so may impact your experience on our website.",
      "{middot}To learn more about managing cookies, visit {link:href-https://allaboutcookies.org/;text-www.allaboutcookies.org}",
    ],
  },
  {
    id: 4,
    title: "Third-Party Cookies",
    textArray: [
      "We may allow trusted third-party services (like Google Analytics) to set cookies on our website for the purposes of analytics. These services are governed by their own privacy and cookie policies.",
    ],
  },
  {
    id: 5,
    title: "Changes to This Policy",
    textArray: [
      "We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated effective date.",
    ],
  },
  {
    id: 6,
    title: "Contact Us",
    textArray: [
      "If you have any questions about our use of cookies, please contact us at:",
      `<strong>Email:</strong> {link:href-mailto:${SUPPORT_EMAIL};text-${SUPPORT_EMAIL}}`,
    ],
  },
];

const CHROME_STORE_EXTENSION_URL =
  "https://chromewebstore.google.com/detail/reach-the-people/fcfdgabjkkablkbgmlgmnplpgnfnmabn";

const BOOK_A_DEMO_URL = "/schedule-demo";

const DATA_DELETION_CONTENT = [
  {
    id: 1,
    title: "Overview",
    textArray: [
      "This page explains how to request deletion of the data ReachThePeople.ai holds about you, including any data obtained through social accounts you connect to the product (Facebook Pages, Instagram, and X).",
    ],
  },
  {
    id: 2,
    title: "Data we may hold",
    textArray: [
      "{middot}Your account details, such as your name, email address, and organization.",
      "{middot}Access tokens and account identifiers for the social accounts you have connected — Facebook Pages, Instagram Business or Creator accounts, and X — which are used only to publish the content you create.",
      "{middot}Campaign content you create in the product, including drafted and published posts.",
    ],
  },
  {
    id: 3,
    title: "How to request deletion",
    textArray: [
      "You can request deletion of your data at any time using either method below:",
      "{middot}In the app: disconnect a social account under Settings to immediately revoke and delete its stored access token, and contact us to delete your account and its associated data.",
      "{middot}By email: send a request to support@reachthepeople.ai from the email address associated with your account, with the subject line 'Data Deletion Request'.",
    ],
  },
  {
    id: 4,
    title: "What happens after your request",
    textArray: [
      "We verify the request, revoke and delete any stored social access tokens, and permanently delete the associated personal data within 30 days. Some records may be retained only where required by law.",
      "You can also remove ReachThePeople.ai's access directly from the connected platform at any time. On Facebook and Instagram, go to Settings → Security → Apps and Websites. On X, go to Settings → Security and account access → Apps and sessions.",
    ],
  },
  {
    id: 5,
    title: "Contact",
    textArray: [
      "For any questions about deleting your data, contact us at support@reachthepeople.ai.",
    ],
  },
];

export {
  EMAIL_REGEX,
  CONTACT_EMAIL,
  CONTACT_PHONE_NUMBER,
  CONTACT_PHONE_NUMBER_DISPLAY,
  CONTACT_PHONE_NUMBER_RAW,
  CONTACT_ADDRESS,
  CONTACT_ADDRESS_SHORT,
  CONTACT_ADDRESS_SHORT_STR,
  COMPANY_NAME,
  SOCIAL_LINKS,
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
  HOMEPAGE_ANCHOR_CONTAINER_IDs,
  HEADER_HEIGHT,
  HEADER_HEIGHT_MOBILE,
  BANNER_HEIGHT,
  PRIVACY_POLICY_CONTENT,
  TERMS_CONDITIONS_CONTENT,
  COOKIES_POLICY_CONTENT,
  DATA_DELETION_CONTENT,
  CHROME_STORE_EXTENSION_URL,
  SUPPORT_EMAIL,
  BOOK_A_DEMO_URL,
};
